// extracted by mini-css-extract-plugin
export var button = "_m8-2";
export var card = "_m8-0";
export var closeButtonContainer = "_m8-3";
export var iconContainer = "_m8-1";